import { createContext } from "react";

export const CarbonContext = createContext(null);